import React from 'react';
import InviteForm from 'invite/components/form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import first from 'lodash/first';
import partial from 'lodash/partial';
import { reqInvite, closeInviteModal, getInviteableProjects } from 'invite/ducks';
import { INVITE_FORM, MESSAGE_REQUIRED } from 'invite/constants';
import { Link } from 'react-router';

export function validate(values, props) {
  const errors = {};
  const creative = props.creative;
  const project = (
    values.project? (props.projects || []).find(p => p.id === parseInt(values.project)) : null
  );

  if (project && creative) {
    const permittedSubcats = creative.permitted_sub_category_ids || [];

    if (
      !creative.is_active || !creative.allowed_to_participate ||
      !permittedSubcats.includes(project.sub_category)
    ) {
      errors.project = <span>
        This creative is not authorized to participate in your project.
        If you have any questions, please <Link target="_blank" to='/help/contact/'>
        contact our support team.</Link>
      </span>;

    } else if (project.elite_only && (!creative.is_elite || !creative.has_enough_portfolio_items)) {
      errors.project = <span>
        Unfortunately, the creative you're trying to invite has a reputation below the minimum
        required to participate in your Elite project. If you have any questions,
        please <Link target="_blank" to='/help/contact/'> contact our support team.</Link>
      </span>;
    } else if (project.platinum_only && !creative.is_platinum) {
      errors.project = <span>
        Unfortunately, the creative you're trying to invite has a reputation below the minimum
        required to participate in your project. If you have any questions,
        please <Link target="_blank" to='/help/contact/'> contact our support team.</Link>
      </span>;
    }
  }

  if (!values.message) {
    errors.message = MESSAGE_REQUIRED;
  } else if (values.message.length > 1024) {
    errors.message = "Message must have a maximum of 1024 characters";
  }

  return errors;
}

export function mapStateToProps(state, { projectId }) {
  const { invite: { modal } } = state;
  const projects = getInviteableProjects(state);
  const initialValues = {
    project: projectId || first(projects).id,
  };

  return {
    modal,
    projects,
    projectOptions: projects.map(({ id, title }) => ({ field: id, label: title })),
    initialValues,
  };
}

export function mapDispatchToProps(dispatch, { creative }) {
  return bindActionCreators({
    onSubmit: partial(reqInvite, creative? creative.id : null),
    cancel: closeInviteModal,
  }, dispatch);
}

const Form = reduxForm({
  form: INVITE_FORM,
  validate,
})(InviteForm);

export default connect(mapStateToProps, mapDispatchToProps)(Form);



// WEBPACK FOOTER //
// ./invite/containers/form.js